import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { RequestModel } from 'src/app/Model/Request.model';
import { SignatureUsersModel } from 'src/app/Model/SignatureUsers.model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import Swal from 'sweetalert2';

export class SignatureUserDialog{
  public name: string;
  public Role: string;
  public Signature: string;
}

@Component({
  selector: 'app-consult-connection-data',
  templateUrl: './consult-connection-data.component.html',
  styleUrls: ['./consult-connection-data.component.css']
})
export class ConsultConnectionDataComponent implements OnInit {

  public Request: RequestModel;
  public requestcode: string;
  public SignatureUsers: SignatureUsersModel[];
  public SignatureUsersArray: SignatureUsersModel[];
  public SignatureUsersList: SignatureUserDialog[];
  public aggregatorName: string
  public IsConnect  :number;
  public type: string;

  constructor(
    public dialog: MatDialog,
    private readonly SpinnerService: NgxSpinnerService,
    private readonly Service: DocumentService,
    private readonly activeRoute: ActivatedRoute,
    private readonly translate: TranslateService,
    private readonly RequesStatusService: RequesStatusService,
    private readonly activeModal: NgbActiveModal,
    private readonly lsService : SessionStorageService
  ) {

    if (this.activeRoute.snapshot.params.requestcode == undefined) {
      this.requestcode = this.lsService.getLSItem("RequestCode");
    } else {
      this.requestcode = this.activeRoute.snapshot.params.requestcode;
    }

   }

  ngOnInit(): void {

    this.GetRequestByCode(false);
    this.getStateConection(this.requestcode)

  }


  public async getStateConection(RequestCode) {
    this.SpinnerService.show()
    await this.RequesStatusService.getStateConection(RequestCode).then(res => {
      if(res == 1){
        this.IsConnect = 1
      }
      if(res == 2){
        this.IsConnect = 2
      }
      if(res == 3){
        this.IsConnect = 3
      }
      if(res == 4){
        this.IsConnect = 4
      }
    })
    this.SpinnerService.hide()
  }

  public async getSignatureUsersByRequest(RequestId) {

    this.SignatureUsersArray = [];
    this.SignatureUsersList = [];

    await this.Service.getSignatureUsersByRequest(RequestId).then(
      async (res) => {
        this.SignatureUsers = res
        this.SignatureUsers.forEach(element => {

          if (element.Signature != undefined) {
            this.SignatureUsersArray.push(element)
            let newUser = new SignatureUserDialog()
            newUser.name = element.FirstName 
                  + (element.MiddleName != undefined ? (" " + element.MiddleName): "") + " " + element.FirstSurname + (element.SecondSurname != undefined ? (" " + element.SecondSurname): "")
            newUser.Role = element.Role == 1 ? this.translate.instant("Request.Label.ChargeCatalog.Supervisor") : element.Role == 2 ? this.translate.instant("Request.Label.ChargeCatalog.Agent") : "unknown"
            newUser.Signature = element.Signature
            this.SignatureUsersList.push(newUser)
          }
        });

      })
  }


  public async GetRequestByCode(noMesaje) {
    if (this.requestcode != undefined) {
      await this.Service.getRequestByCode(this.requestcode).then(
        async (res) => {
          this.Request = res;
          if (this.Request == undefined) {
            if (!noMesaje) {
              Swal.fire({
                icon: "error",
                title: this.translate.instant("Document.Messages.2"),
                showConfirmButton: false,
                timer: 3000,
              });
            }


          } else {
            this.type = this.Request.ConnectionType.toString()
            if (this.Request.RequestIdentification.length != 0) {
              if (!noMesaje) {
                this.getSignatureUsersByRequest(this.Request.Id)


              }
            } else {
              if (!noMesaje) {
                Swal.fire({
                  icon: "error",
                  title: this.translate.instant("Document.Messages.7"),
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            }
          }
        }
      );

    } else {
      Swal.fire({
        icon: "error",
        title: this.translate.instant('Document.Messages.5'),
        showConfirmButton: false,
        timer: 3000,
      });


    }
  }

  closeModal(){
    this.activeModal.dismiss();
  }


}
